export const USE_CACHE_HEADER = 'X-Use-Cache';

export function fallback(xhr) {
  xhr.setRequestHeader(USE_CACHE_HEADER, 'fallback');
}


// WEBPACK FOOTER //
// ./src/js/util/cache-methods.js